/**
 * Composant pour protéger les routes clients (authentification requise)
 */

import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress, Box, Typography } from '@mui/material';
import { fetchProfile } from '../redux/slices/clientAuthSlice';
import { RootState, AppDispatch } from '../redux/store';

interface Props {
  children: React.ReactNode;
}

export default function ProtectedClientRoute({ children }: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated, isLoading, user } = useSelector(
    (state: RootState) => state.clientAuth
  );

  useEffect(() => {
    // Si on a un token mais pas de user, récupérer le profil
    const token = localStorage.getItem('clientAccessToken');
    if (token && !user && !isLoading) {
      dispatch(fetchProfile());
    }
  }, [dispatch, user, isLoading]);

  // Afficher un loader pendant la vérification
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="body1" color="text.secondary">
          Vérification de votre authentification...
        </Typography>
      </Box>
    );
  }

  // Si pas authentifié, rediriger vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/client/login" replace />;
  }

  // Si authentifié, afficher le contenu
  return <>{children}</>;
}
